import React from "react";
import "../../../../../Assets/Styles/JPADetailsModal.scss";

const CandidateDetailsModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenText = (Text, Length) => {
    if (Text !== undefined) {
      if (Text.length <= Length) {
        return Text;
      } else {
        let Short = Text.slice(0, Length - 4) + " ...";
        return (
          <>
            <p className="popup-text">{Text}</p>
            {Short}
          </>
        );
      }
    }
  };

  const displaySkills = () => {
    let Skills = [];
    props.candidate.topSkills.map((Skill) => {
      Skills.push(Skill.title);
    });
    return Skills.join(', ');
  };

  return (
    <div className="details-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="details-modal">
        <section className="details-modal-head">
          <span>
            <h1>
              {props.candidate.firstName + " " + props.candidate.lastName}
            </h1>
            <p>
              {props.candidate
                ? shortenText(props.candidate.currentPositionTitle, 30)
                : null}
            </p>
          </span>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="details-modal-body">
          <div className="details-info">
            <section className="info-row">
              <p className="details-info row-name">
                {translateText("top_skills")}
              </p>
              <p className="details-info">
                {props.candidate.topSkills
                  ? displaySkills()
                  : translateText("not_available")}
              </p>
            </section>
            <section className="info-row">
              <p className="details-info row-name">
                {translateText("education")}
              </p>
              <p className="details-info">
                {props.candidate.higherEducation
                  ? props.candidate.higherEducation.degree +
                    " " +
                    props.candidate.higherEducation.major
                  : translateText("not_available")}
              </p>
            </section>
            <section className="info-row">
              <p className="details-info row-name">
                {translateText("languages")}
              </p>
              <p className="details-info">
                {props.candidate.language
                  ? props.candidate.language.toString()
                  : translateText("not_available")}
              </p>
            </section>
            <section className="info-row">
              <p className="details-info row-name">
                {translateText("years_of_experience")}
              </p>
              <p className="details-info">
                {props.candidate.yearsOfExperience
                  ? props.candidate.yearsOfExperience
                  : translateText("not_available")}
              </p>
            </section>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CandidateDetailsModal;
